import axios from 'axios'
import { baseURL, contentType, invalidCode, messageDuration, noPermissionCode, requestTimeout, successCode, debounce } from '@/config/settings'
import { Loading, Message } from 'element-ui'
import { getCookies, removeCookies } from '@/libs/util'

import _ from 'lodash'

const service = axios.create({
  baseURL,
  timeout: 10000 // 请求超时时间
})

axios.defaults.withCredentials = true// 携带cookie

service.interceptors.request.use(
  config => {
    
	const token = getCookies('webtoken')
	
	if (token) {
		config.headers['Authori-zation'] = 'Bearer ' + token;
	} else {
		config.headers['Authori-zation'] = '';
	}

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

    response => {
        let status = response.data ? response.data.status : 0
        const code = status
        switch (code) {
        case 200:
            return response.data
        case 400:case 400011:case 400012:
            return Promise.reject(response.data || { msg: '未知错误' })
        case 410000:
        case 410001:
        case 410002:
            localStorage.clear()
            removeCookies('webtoken')
            removeCookies('webexpires_time')
            removeCookies('uuid')
            router.replace({path:'/index'})
            break
        case 410003:
            removeCookies('kefuInfo')
            removeCookies('kefu_token')
            removeCookies('kefu_expires_time')
            removeCookies('kefu_uuid')
            router.replace({path:'/index'})
        default:
            break
        }
    },
    error => {
        Message.error(error.msg)
        return Promise.reject(error)
    }
)
export default service
